const ACADEMIC_YEAR_START_MONTH_INDEX = 3

const trimAcademicYear = (value) => String(value || '').trim()

const sanitizeAcademicYear = (value) =>
  String(value || '')
    .trim()
    .replace(/[–—−]/g, '-')
    .replace(/\s+/g, '')
    .replace(/\//g, '-')

export const parseAcademicYear = (value) => {
  const trimmed = trimAcademicYear(value)
  if (!trimmed) return null

  const match = /^(\d{4})-(\d{2}|\d{4})$/.exec(sanitizeAcademicYear(trimmed))
  if (!match) return null

  const startYear = Number(match[1])
  const endToken = match[2]
  let endYear = Number(endToken)

  if (endToken.length === 2) {
    const centuryBase = Math.floor(startYear / 100) * 100
    endYear = centuryBase + endYear
    if (endYear < startYear) endYear += 100
  }

  if (endYear !== startYear + 1) return null
  return { startYear, endYear }
}

export const isAcademicYear = (value) => Boolean(parseAcademicYear(value))

export const formatAcademicYear = (value) => {
  const parsed = parseAcademicYear(value)
  if (!parsed) return trimAcademicYear(value)
  return `${parsed.startYear}-${parsed.endYear}`
}

export const getCurrentAcademicYear = (referenceDate = new Date()) => {
  const date = referenceDate instanceof Date ? new Date(referenceDate.getTime()) : new Date(referenceDate)
  const year = date.getMonth() >= ACADEMIC_YEAR_START_MONTH_INDEX ? date.getFullYear() : date.getFullYear() - 1
  return `${year}-${year + 1}`
}

export const getAcademicYearOptions = ({
  pastCount = 1,
  futureCount = 2,
  referenceDate = new Date(),
} = {}) => {
  const current = parseAcademicYear(getCurrentAcademicYear(referenceDate))
  if (!current) return []

  const options = []
  for (let offset = -pastCount; offset <= futureCount; offset += 1) {
    const startYear = current.startYear + offset
    options.push(`${startYear}-${startYear + 1}`)
  }
  return options
}

const isPlainObject = (value) => Object.prototype.toString.call(value) === '[object Object]'

export const normalizeAcademicYearData = (value) => {
  if (Array.isArray(value)) return value.map((item) => normalizeAcademicYearData(item))
  if (!isPlainObject(value)) return value

  return Object.fromEntries(
    Object.entries(value).map(([key, itemValue]) => [
      key,
      key === 'academicYear' && typeof itemValue === 'string'
        ? formatAcademicYear(itemValue)
        : normalizeAcademicYearData(itemValue),
    ])
  )
}
